import "../css/Loading.css";

const Loading = ({visible, noBackground, text}) => {
    return <div className = "loader-container" style={{backgroundColor: noBackground && "transparent", boxShadow: noBackground && "0 0 0 0"}} data-status={visible ? "show" : "hidden"}>
        <div className="loader">
            <div className="inner one"></div>
            <div className="inner two"></div>
            <div className="inner three"></div>
        </div>

        <span>{text}</span>
    </div>
}

export default Loading